import React, { useEffect, useRef, useState } from 'react'
import { Content } from './style'
import LoadingComponent from '../../../components/LoadingComponent'
import { ButtonCreate, FilterWrapper, LeftSide, OptionsButton, RightSide, SectionName, SubHeaderContainer, Tab, TabsDiv } from '../../../components/styles/subheader-style'
import { Outlet, useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import certificate from '../../../assets/certificates/SubHeader/certificate.svg'
import param from '../../../assets/certificates/SubHeader/param.svg'
import EditStructureModal from '../../../components/Modals/EditStructure'
import { ParamType } from './CreateParam'
import FilterMenu from '../../../components/SubHeaderFilter/FilterMenu'
import { FilterIcon } from 'lucide-react'
import { Filter, Header } from '../../../components/SubHeaderFilter/types'
import AppliedFiltersDisplay from '../../../components/SubHeaderFilter/AppliedFiltersDisplay'
import { TypeMainOutlet } from '..'
import ApiService from '../../../services/ApiService'


export interface CertificateOutletType {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
  modal: boolean
  setModal: React.Dispatch<React.SetStateAction<boolean>>
  param: ParamType
  setParam: React.Dispatch<React.SetStateAction<ParamType>>
  clickedStructure: number | null
  setClickedStructure: React.Dispatch<React.SetStateAction<number | null>>
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  appliedFilters: Filter[]
  setAppliedFilters: React.Dispatch<React.SetStateAction<Filter[]>>
  search: string
}

const certificateTableHeaders: Header[] = [
  { key: 'param', label: 'Parâmetro', type: 'string' },
  { key: 'supplier', label: 'Fornecedor', type: 'string' },
  { key: 'customer', label: 'Cliente', type: 'string' },
  { key: 'heatNumber', label: 'Nº da corrida', type: 'string' },
  { key: 'codeOpString', label: 'Nº da OP', type: 'string' },
  { key: 'purchaseOrderNumber', label: 'Nº da ordem de compra', type: 'string' },
  { key: 'standard', label: 'Norma', type: 'string' },
  { key: 'invoiceNumber', label: 'NF', type: 'string' },
]

const paramTableHeaders: Header[] = [
  { key: 'name', label: 'Nome do parâmetro', type: 'string' },
  { key: 'class', label: 'Classe', type: 'string' },
  { key: 'family', label: 'Família', type: 'string' },
  { key: 'astm', label: 'ASTM', type: 'string' },
  { key: 'uns', label: 'UNS', type: 'string' },
  { key: 'din', label: 'DIN', type: 'string' },
  { key: 'aisi', label: 'AISI', type: 'string' },
  { key: 'others', label: 'Outros', type: 'string' },
]

const tabs = [
  { path:'', image: certificate, name: 'Certificados' },
  { path:'params', image: param, name: 'Parâmetros' },
]

const CertificateSubHeader:React.FC<{tabIndexActived: number | null, handleApplyFilter: (newFilter: Filter) => void; appliedFilters: Filter[]}> = ({tabIndexActived, handleApplyFilter, appliedFilters}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isFilterMenuOpen, setIsFilterMenuOpen] = useState<boolean>(false)
  const filterButtonRef = useRef<HTMLDivElement | null>(null)
  const [dynamicCertificateHeaders, setDynamicCertificateHeaders] = useState<Header[]>([
    { key: 'param', label: 'Parâmetro', type: 'string' },
    { key: 'supplier', label: 'Fornecedor', type: 'string' },
    { key: 'customer', label: 'Cliente', type: 'string' },
    { key: 'heatNumber', label: 'Nº da corrida', type: 'string' },
    { key: 'codeOpString', label: 'Nº da OP', type: 'string' },
    { key: 'purchaseOrderNumber', label: 'Nº da ordem de compra', type: 'string' },
    { key: 'standard', label: 'Norma', type: 'string' },
    { key: 'invoiceNumber', label: 'NF', type: 'string' },
    { key: 'type', label: 'Tipo do certificado', type: 'string', selectOptions: [] },
    { key: 'date', label: 'Data de criação', type: 'date' },
  ])

  useEffect(() => {
    if (tabIndexActived === 0) {
      ApiService.certificates.getTypes()
        .then((response: any) => {
          if (response.data && Array.isArray(response.data)) {
            const options: { value: string; label: string }[] = []
            response.data.forEach((item: any) => {
              if (item.name === 'Origem / Qualidade' || item.id === 1) {
                options.push({ value: 'Origem', label: 'Origem' })
                options.push({ value: 'Qualidade', label: 'Qualidade' })
              } else {
                options.push({ value: item.name, label: item.name })
              }
            })
            setDynamicCertificateHeaders(prev =>
              prev.map(h => h.key === 'type' ? { ...h, selectOptions: options } : h)
            )
          }
        })
        .catch((error: any) => {
          console.error(error)
        })
    }
  }, [tabIndexActived])
  
  return(
    <SubHeaderContainer>
    <LeftSide>
      <SectionName>
        {location.pathname.includes('create') || location.pathname.includes('edit') ? 
          `${tabIndexActived === 1 ? 'Parâmetro da norma' : location.pathname.includes('edit') ? 'Editar certificado' : 'Novo certificado'}`: 'Certificados'}
      </SectionName>
      {!location.pathname.includes('create') || location.pathname.includes('edit') ?
        <TabsDiv>
          {tabs.map((tab, index) => (
          <Tab
            key={index}
            $isFirst={index === 0}
            $isLast={index === tabs.length - 1}
            $isActive={tabIndexActived === index}
            onClick={() => {
              if(index !== tabIndexActived) navigate(tab.path)
            }}
          >
              <img src={tab.image} alt={`${tab.path}-icon`} />
              {tab.name}
            </Tab>
          ))}
        </TabsDiv> : null
      }
    </LeftSide>
    {!location.pathname.includes('create') || location.pathname.includes('edit') ?
      <RightSide>
        <FilterWrapper>
        <OptionsButton ref={filterButtonRef} onClick={() => setIsFilterMenuOpen(true)}>
          <FilterIcon size={10} />
        </OptionsButton>
        {isFilterMenuOpen && (
          <FilterMenu
            headers={tabIndexActived === 1 ? paramTableHeaders : dynamicCertificateHeaders}
            onApplyFilter={handleApplyFilter}
            onClose={() => setIsFilterMenuOpen(false)}
            anchorRef={filterButtonRef}
            filters={appliedFilters}
          />
        )}
        </FilterWrapper>
        <ButtonCreate onClick={() => {
          if(tabIndexActived === 0) return navigate('/panel/certificates/create')
          return navigate('/panel/certificates/params/create')
        }}>+ Criar {tabIndexActived === 0 ? 'certificado' : 'parâmetro'}</ButtonCreate>
      </RightSide>
    : null}
  </SubHeaderContainer>
  )
}

const CertificatesContent: React.FC = () => {
  const [ loading, setLoading ] = useState<boolean>(false)
  const [ tabIndex, setTabIndex ] = useState<number | null>(null)
  const [appliedFilters, setAppliedFilters] = useState<Filter[]>([])
  const { search } = useOutletContext<TypeMainOutlet>()
  const [ param, setParam ] = useState<ParamType>({
    structures: [],
    name: '',
    class: '',
    family: '',
    astm: '',
    uns: '',
    din: '',
    aisi: '',
    others: '',
  })
  const [ modal, setModal ] = useState<boolean>(false)
  const [ clickedStructure, setClickedStructure ] = useState<number | null>(null)

  const handleApplyFilter = (newFilter: Filter) => {
    setAppliedFilters(prev => [...prev, newFilter])
  }
  const handleRemoveFilter = (index: number) => {
    setAppliedFilters(prev => prev.filter((_, i) => i !== index))
  }
  const handleClearAll = () => {
    setAppliedFilters([])
  }

  useEffect(() => {
    setParam(() => ({
      structures:[],
      name: '',
      class: '',
      family: '',
      astm: '',
      uns: '',
      din: '',
      aisi: '',
      others: '',
    }))
  }, [tabIndex])

  return (
    <>
  <CertificateSubHeader tabIndexActived={tabIndex} handleApplyFilter={handleApplyFilter} appliedFilters={appliedFilters} />
      <AppliedFiltersDisplay
        filters={appliedFilters}
        onRemoveFilter={handleRemoveFilter}
        onClearAll={handleClearAll}
      />
      {loading === true && <LoadingComponent />}
      <Content>
        <Outlet
          context={{
            tabIndex,
            setTabIndex,
            modal,
            setModal,
            param,
            setParam,
            clickedStructure,
            setClickedStructure,
            setLoading,
            appliedFilters,
            search,
          }}
        />
      </Content>
      {modal && 
      <EditStructureModal 
        onClose={() => setModal(false)}
        param={param}
        setParam={setParam}
        clickedStructure={clickedStructure || 0}
      />}
    </>
  )
}
export default CertificatesContent
